import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { BasicWebkData } from 'ngx-esprio-shared';
import { v4 } from 'uuid';
import { ModalsActions } from '../../modals/actions/modals.actions';
import { UserDataApiActions } from '../actions/user-data-api.actions';

export interface BasicWebkHistoryState extends EntityState<BasicWebkData> {}

export const basicWebkHistoryAdapter = createEntityAdapter<BasicWebkData>({
  selectId: () => v4(),
});

const initialState = basicWebkHistoryAdapter.getInitialState();

export const basicWebkHistoryReducer = createReducer(
  initialState,
  on(UserDataApiActions.getUserBasicWebkDataSuccess, (state, { payload }) =>
    basicWebkHistoryAdapter.upsertMany(payload, { ...state })
  ),
  on(UserDataApiActions.purgeUserData, (state) => basicWebkHistoryAdapter.removeAll({ ...state })),
  on(ModalsActions.closeUserDetailsModal, (state) =>
    basicWebkHistoryAdapter.removeAll({ ...state })
  ),
  on(UserDataApiActions.getUserBasicWebkData, (state) =>
    basicWebkHistoryAdapter.removeAll({ ...state })
  )
);
